import { render, staticRenderFns } from "./resourceDetails.vue?vue&type=template&id=4ce356c8&scoped=true&"
import script from "./resourceDetails.vue?vue&type=script&lang=js&"
export * from "./resourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./resourceDetails.vue?vue&type=style&index=0&id=4ce356c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce356c8",
  null
  
)

export default component.exports